import React from 'react'
import './ProcessItem.css'

export interface ProcessItemProps {
  number: string
  title: string
  description: string
  className?: string
}

export const ProcessItem: React.FC<ProcessItemProps> = ({
  number,
  title,
  description,
  className = '',
}) => {
  return (
    <div className={`process-item ${className}`}>
      <div className="process-item-number">{number}</div>
      <div className="process-item-content">
        <h4 className="process-item-title">{title}</h4>
        <p className="process-item-description">{description}</p>
      </div>
    </div>
  )
}
